import React from "react";
import ContentBlock from "../components/ContentBlock/ContentBlock";
import ReactDOM from "react-dom";
import getRowData from "../assets/store/getRowData";
import getParentDiv from "../assets/store/getParentDiv";
import { getDefaultFontFamily } from "../assets/store/getDefaultFontFamily";

const renderContentBlock = () => {
    const contentBlockRows = document.getElementsByClassName(
        "ds-content-block-row"
    );
    const { drive_service_divs, oems, client } = window.DriveServiceSpecials;
    const { default_oem, links } = client;
    const defaultFontFamily = getDefaultFontFamily({
        fontFamily: client?.font_family,
    });

    for (const row of contentBlockRows) {
        const parent = getParentDiv(drive_service_divs, row);
        const rowData = getRowData(parent.div_rows, parseInt(row.id));
        const { menu_page_content, content_block_type } = rowData;

        const commonDataAttr = {
            "data-divid": parent.id,
            "data-rowid": rowData.id,
            "data-clientid": client.id,
        };

        const contentBlockProps = {
            menuPageContent: menu_page_content,
            rowData: rowData,
            oem: default_oem || oems[0] || null,
            links,
            defaultFontFamily,
            dataAttributes: commonDataAttr,
            client,
            type: content_block_type,
        };

        ReactDOM.render(<ContentBlock {...contentBlockProps} />, row);
    }
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderContentBlock();
window.renderContentBlock = renderContentBlock;

export default renderContentBlock;
